export const requiredMessage = 'Please answer this question to continue'
